export default class PermissionAdapter {

    constructor(permission){
        this._permission = permission;
    }
    adapt() {
        return {
            "CURRENT_ACCOUNT_PERMISSION": "Cuenta Corriente",
            "PURCHASE_ORDER_PERMISSION": "Órdenes de Compra",
            "ORDER_PERMISSION": "Ver Pedidos",
            "USER_PERMISSION": "Usuarios",
            "CREATE_ORDER_PERMISSION": "Crear Pedidos",
            "SUPPORT_PERMISSION": "Soporte",
            "BACKOFFICE_USER_PERMISSION": "Usuarios Backoffice",
            "AUTHORIZATION_PERMISSION": "Autorizaciones",
            "FREE_ORDER_CONFIRMATION_REQUEST_PERMISSION": "Autorizaciones Pedidos Sin Cargo",
            "ADVANCE_PAYMENT_REQUEST_PERMISSION": "Autorizaciones Pagos Anticipados",
            "JUDICIAL_MANAGEMENT_REQUEST_PERMISSION": "Autorizaciones Pases a Gestión Judicial",
            "ERP_SUPPORT_PERMISSION": "Soporte ERP",
            "EDI_SUPPORT_PERMISSION": "Soporte EDI",
            "CURRENT_ACCOUNT_SUPPORT_PERMISSION": "Soporte Cuenta Corriente",
            "GENERAL_SUPPORT_PERMISSION": "Soporte Tienda",
            'CLOSER_PERMISSION': "Closer",
            'DELIVERY_SITE_ONBOARDING_PERMISSION': "Alta de Punto de Entrega",
            'COMMERCIAL_PERMISSION': "Comercial",
            'LOGISTICS_PERMISSION': "Logística",
            'TAX_PERMISSION': "Impuestos",
            'FINANCE_PERMISSION': "Finanzas",
            'COMMERCIAL_AUTHORIZATION_PERMISSION': "Autorizaciones Comerciales",
            'LOGISTICS_AUTHORIZATION_PERMISSION': "Autorizaciones Logísticas",
            'TAX_AUTHORIZATION_PERMISSION': "Autorizaciones Impuestos",
            'FINANCE_AUTHORIZATION_PERMISSION': "Autorizaciones Finanzas",
            'ONBOARDINGS_ERP_IMPORTER_PERMISSION': "Altas (Cliente y Punto de Entrega) - Importador ERP",
            'BUDGET_PERMISSION': "Presupuestos",
            'SUPERUSER_PERMISSION': "Superusuario",
            'DASHBOARD_PERMISSION': "Dashboard",
            'DEMO_PERMISSION': "Demo Tienda",
            'SOLD_BOXES_BY_CUSTOMER_AND_ARTICLE_PERMISSION': "Cajas por Artículo",
            'KAM_DAILY_REPORT_PERMISSION': "Reporte diario a KAM",
            'PAYMENT_REMINDER_PERMISSION': "Recordatorio de pago",
            'HIGH_RISK_CLASSIFICATION_PERMISSION': "Clasificación de alto riesgo",
            'LOGISTICS_SYSTEM_PERMISSION': "Sistema de Logística",
            'ALLOWANCES_CREDIT_NOTES_PERMISSION': "NCs de bonificaciones",
            'CUSTOMER_SERVICE_AGENT_PERMISSION': "Agente de atención",
            'HORECA_CHANNEL_HEAD_PERMISSION': "Jefe de Horeca",
            'RETAIL_CHANNEL_HEAD_PERMISSION': "Jefe de Retail",
            'CHAINS_CHANNEL_HEAD_PERMISSION': "Jefe de Cadenas",
            'COMMERCIAL_MANAGER_PERMISSION': "Gerente Comercial",
        }[this._permission];
    }
}
